/**
 * ADP URLs. Shared because the portal's logout uses MARKETPLACE, and the API's
 * vendors/adp/config.ts, which re-exports these, loads the API's env on import.
 */
export const ADP_URLS = {
  /**
   * ADP Marketplace (subscription events, OAuth for marketplace). Users who
   * signed in from the app tile go back here on logout: ADP's Integration
   * Report asks that "any logout flows from your product should redirect to
   * the base {marketplace url}".
   */
  MARKETPLACE: 'https://apps.adp.com',

  /** ADP API (B2B Connector operations) */
  API: 'https://api.adp.com',

  /** ADP OAuth (subscriber tokens) */
  OAUTH: 'https://accounts.adp.com',
} as const;
